import { httpRequest } from "../../../http";
import { NetworkResource } from "@models/networkResource";
import { NetworkResourceSerializer } from "@models/serializers/networkResourceSerializer";

export class CommandUpdateNetworkResource {
  async run(
    resourceId: number,
    data: Partial<NetworkResource>,
  ): Promise<NetworkResource> {
    try {
      const response = await httpRequest<any>(
        `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/network_accounts/network_resources/${resourceId}/`,
        {
          method: "PATCH",
          body: JSON.stringify(data),
        },
      );

      return this.deserialize(response);
    } catch (error) {
      console.error("Error updating network account:", error);
      throw error;
    }
  }

  private deserialize(data: any): NetworkResource {
    const serializer = new NetworkResourceSerializer();
    return serializer.deserialize(data);
  }
}
